import { makeStyles } from 'tss-react/mui'
import Img from 'src/assets/images/dtlOriginals/bgimg.jpg'
import { nunito_sans } from '@styles/fonts'

const useStyles = makeStyles()((theme) => ({
  root: {},
  container: {
    height: 'auto',
    backgroundImage: `url(${Img?.src})`,
    backgroundRepeat: 'no-repeat',
    borderRadius: '40px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    margin: theme.spacing(0, 22),

    [theme.breakpoints.down('md')]: {
      backgroundSize: 'cover',
      margin: theme.spacing(0, 0),
    },
  },
  containerZenMode: {
    // margin: theme.spacing(32, 0),
    height: 'auto',
    border: '1px solid black',
    backgroundRepeat: 'no-repeat',
    borderRadius: '45px',
    backgroundPosition: 'center',
    backgroundSize: '100% 100%',
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(12, 0, 12),
    },
  },
  heading: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: ' normal',
    fontWeight: '800',
    fontSize: '40px',
    lineHeight: '120%',
    textTransform: 'uppercase',
    color: '#000000',
    textAlign: 'start',
    margin: theme.spacing(10, 0, 0),

    [theme.breakpoints.down('sm')]: {
      fontSize: '24px',
      width: '100%',
      lineHeight: 'normal',
      textAlign: 'center',
    },
  },

  text: {
    width: '95%',
    ...theme.textPrimary,
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '24px',
    color: '#000000',
    opacity: '0.7',
    textAlign: 'start',
    marginTop: theme.spacing(2),

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'center',
    },
  },
  btn: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    color: theme.custom.lightFont,
    backgroundColor: theme.custom.blackColor,
    ':hover': {
      background: theme.custom.blackColor,
    },
  },

  img: {
    img: {
      width: '250px',
      height: '240px',
      margin: theme.spacing(8, 0, 0),
    },
  },
  recommendBtn: {
    background: 'black',
    color: 'white',
    '&:hover': {
      background: 'white',
      color: 'black',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: 1,
    },
  },

  iconsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: theme.spacing(8),
    '@media (max-width:1225px)': {
      marginBottom: '30px',
      textAlign: 'center',
    },
    a: {
      background: 'black',
      cursor: 'pointer',
      color: 'white',
      padding: theme.spacing(2, 5),
      borderRadius: '130px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      ...theme.textPrimary,
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '16px',
      lineHeight: '22px',
      textTransform: 'uppercase',
      textDecoration: 'none',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        margin: 'auto',
        marginBottom: theme.spacing(4),
      },
      p: {
        padding: 0,
        margin: 0,

        marginLeft: '10px',
      },
      svg: {
        marginTop: '3px',
      },
      marginRight: '20px',
    },
  },
}))

export default useStyles
